(function($) {
    $.fn.serializeObject = function() {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    $.fn.headerSearch = function() {
        function makeRequest($container, ref, cb) {
            $container.find('.js-livesearch_results').remove();
            $.post('/search/search/', {ref: ref}, function(data) {
                var $content = $(data);
                $container.append($content);
                cb($content.filter('.js-livesearch_results'));
            }, 'html');
        }

        return this.each(function () {
            var $this = $(this), $refInput = $this.find('input.js-header-search-ref-input');
            var $form = $this.find('.js-header_search_form');

            $form.on('submit', function(e) {
                e.preventDefault();
                return false;
            });

            $this.click(function(e){
                if (!$this.hasClass('is-active')) {
                    $this.addClass('is-active');
                    $refInput.focus();
                }

                $(document).one('click',function() {
                    $this.removeClass('is-active');
                    $this.find('.js-livesearch_results').remove();
                    $refInput.val('');
                });

                e.stopPropagation();
            });

            var popup = false, $popup, searchResults = {}, dec = 1;

            $refInput.keyup(function(e) {
                if (popup) {
                    if (e.keyCode == 27) {
                        $this.find('.js-livesearch_results').remove();
                        $refInput.val('');
                        popup = false;
                    }

                    if (e.keyCode == 13) {
                        var $selected = $popup.find('.js-history-item > a.is-hover');
                        if ($selected.length) {
                            e.stopImmediatePropagation();
                            window.location.href = $selected.attr('href');
                            return;
                        }

                        if (searchResults['count'] && searchResults['count'] > 1) {
                            e.stopImmediatePropagation();
                            window.location.href = searchResults['searchUrl'];
                        } else if (searchResults['count'] && searchResults['count'] == 1) {
                            e.stopImmediatePropagation();
                            window.location.href = $popup.find('.js-history-item:eq(0)').data('url');
                        }
                    }

                    if (e.keyCode == 38 || e.keyCode == 40) {
                        var currentIndex = $popup.find('.js-history-item > a.is-hover').parent().index();
                        $popup.find('.js-history-item > a').removeClass('is-hover');

                        if (e.keyCode == 38) {
                            currentIndex = currentIndex == -1 ? searchResults['count'] - 1 : currentIndex - 1;
                        } else if (e.keyCode == 40) {
                            currentIndex = currentIndex == -1 ? 0 : currentIndex + 1;
                            if (currentIndex > searchResults['count'] - (searchResults['showAll'] ? 0 : 1)) {
                                currentIndex = 0;
                            }
                        }

                        $popup.find('.js-history-item > a').eq(currentIndex).addClass('is-hover');
                    }
                }
            });

            $refInput.keyup($.debounce(function(e) {
                if (e.keyCode == 13 && !popup || ((e.keyCode == 38 || e.keyCode == 40) && popup)) {
                    return;
                }

                var ref = $refInput.val();
                if (ref) {
                    popup = false;
                    makeRequest($this, $refInput.val(), function($content) {
                        popup = true;
                        $popup = $content;
                        searchResults = $popup.data('results');
                    });
                } else {
                    $this.find('.js-livesearch_results').remove();
                }
            }, 300));
        });
    };

    // [ google-map
    $.fn.googleMap = function(options) {
        var settings = $.extend({}, options);

        function codeAddress(map, geocoder, address) {
            geocoder.geocode( { 'address': address}, function(results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    map.setCenter(results[0].geometry.location);
                    map.fitBounds(results[0].geometry.bounds);
                    console.log(results);
                }
            });
        }

        return this.each(function () {
            var $this = $(this), data = $this.data('location'), map, marker, placeLatLng, geocoder;
            if ( data['lat'] && data['lng']) {
                placeLatLng = {lat: parseFloat(data['lat']), lng: parseFloat(data['lng'])};

                map = new google.maps.Map($this[0], {
                    center: placeLatLng,
                    scrollwheel: false,
                    scaleControl: true,
                    zoom: 15
                });

                // Create a marker and set its position.
                marker = new google.maps.Marker({
                    map: map,
                    position: placeLatLng,
                    title: data['ref']
                });
            } else {
                map = new google.maps.Map($this[0], {
                    scrollwheel: false,
                    scaleControl: true
                });

                geocoder = new google.maps.Geocoder();
                codeAddress(map, geocoder, data['address']);
            }
        });
    };
    // google-map ]

    // [ my-selection
    $.fn.mySelection = function(options) {
        var settings = $.extend({
            inListText: 'Убрать из подборки',
            notInListText: 'Добавить к сравнению',
            textContainerSelector: '.js-my-selection-text'
        }, options);

        function updateData($element, data) {
            $element.data('mySelection', data);
        }

        function addToSelection(ref, callback) {
            $.post('/async/add-selection/', {ref: ref}, function(data) {
                callback(data);
            }, 'json');
        }

        function removeFromSelection(ref, callback) {
            $.post('/async/remove-selection/', {ref: ref}, function(data) {
                callback(data);
            }, 'json');
        }

        return this.each(function () {
            var $this = $(this), data = $this.data('mySelection'), $textContainer = $this.find(settings['textContainerSelector']);

            if (!data['inSelection']) {
                $textContainer.text(settings['notInListText']);
            } else {
                $textContainer.text(settings['inListText']);
            }

            $this.click(function(e) {
                e.preventDefault();

                if (data['inSelection']) {
                    removeFromSelection(data['ref'], function(response) {
                        data['inSelection'] = false;
                        $textContainer.text(settings['notInListText']);
                        updateData($this, data);
                        $(document).trigger('plugins.my-selection', response['count']);
                    });
                } else {
                    addToSelection(data['ref'], function(response) {
                        data['inSelection'] = true;
                        $textContainer.text(settings['inListText']);
                        updateData($this, data);
                        $(document).trigger('plugins.my-selection', response['count']);
                    });
                }
            });

            $this.show();
        });
    };
    // my-selection ]

    // [ Card price plugin
    $.fn.objectPriceSwitcher = function(options) {
        var settings = $.extend({
            sale: 'Продажа',
            rent: 'Аренда'
        }, options);

        return this.each(function () {
            var $this = $(this), $price = $this.find('.js-price-value'), $label = $this.find('.js-price-type'), data = $this.data('prices');
            if (!data['sale'] || !data['rent']) return;
            var current = data['default'];

            updateUI();

            $label.click(function() {
                current = current == 'sale' ? 'rent' : 'sale';
                updateUI();
            });

            function updateUI() {
                $price.text(data[current]);
                $label.text(settings[current]);
            }
        });
    };
    // Card price plugin ]

    // [ Credit modal plugin
    $.fn.creditModal = function(options) {
        var settings = $.extend({
            hashTracking: true,
            closeOnOutsideClick: false,
            modifier: 'is-default'
        }, options);

        var $modal = $('[data-remodal-id=credit-calc]');

        return this.each(function () {
            var $this = $(this);
            var modalInst = $modal.remodal(settings);

            $this.click(function() {
                modalInst.open();
            });

            $modal.on('closed', function (e) {
                history.pushState("", document.title, window.location.pathname);
                $(document).trigger('creditModal.afterClose');
            });
        });
    };
    // Credit modal plugin ]
    
    // [ Credit calculator plugin
    $.fn.creditCalc = function(options) {
        var settings = $.extend({
            percent: {min: 10, max: 65, val: 25},
            duration: {min: 5, max: 25, val: 10},
            aboveMax: 2000000,
            rates: [
                {min: 5, max: 10, rate: 3},
                {min: 11, max: 15, rate: 3.2},
                {min: 16, max: 20, rate: 3.55},
                {min: 21, max: 25, rate: 3.75}
            ]
        }, options);

        var calc = new Calc(settings['rates'], settings['aboveMax']);
        var $inputSize = $('#sliderSize_input');
        var $inputTime = $('#sliderTime_input');

        var moneyFormat = wNumb({
            thousand: ' ',
            decimals: 0,
            postfix: ' €'
        });

        var sliderSize = document.getElementById('sliderSize');
        var sliderTime = document.getElementById('sliderTime');

        if (sliderSize) {
            noUiSlider.create(sliderSize, {
                start: settings['percent']['val'],
                connect: "lower",
                step:1,
                range: {
                    'min': settings['percent']['min'],
                    'max': settings['percent']['max']
                }
            });
        }

        if (sliderTime) {
            noUiSlider.create(sliderTime, {
                start: settings['duration']['val'],
                connect: "lower",
                step:1,
                range: {
                    'min': settings['duration']['min'],
                    'max': settings['duration']['max']
                }
            });
        }

        function Calc(rates, above) {
            var _rates = rates, _above = above;
            var _price, _percent, _duration, _rate, _payment, _credit;
            
            this.init = function(price, percent, duration) {
                _price = price;
                _percent = percent;
                _duration = duration;

                _calculateRate();
                _calculateCredit();
                _calculatePayment();
            };
            
            this.setPercent = function (percent) {
                _percent = percent;
                _calculateCredit();
                _calculatePayment();
            };
            
            this.setDuration = function (duration) {
                _duration = duration;
                _calculateRate();
                _calculatePayment();
            };
            
            this.isAbove = function () {
                return _price > _above;
            };
            
            this.getRate = function () {
                return _rate;
            };

            this.getCredit = function() {
                return _credit;
            };

            this.getPayment = function() {
                return _payment;
            };

            function _calculateCredit() {
                _credit = _price*_percent/100;
            }
            
            function _calculateRate() {
                for (var i=0; i < _rates.length; ++i) {
                    var item = _rates[i];
                    if (item['min'] <= _duration && item['max'] >= _duration) {
                        _rate = item['rate'];
                        break;
                    }
                }
            }

            // used anuitent payment
            function _calculatePayment() {
                var a = 1 + _rate / 1200;
                var k = Math.pow(a, (_duration * 12)) * (a - 1) / (Math.pow(a, (_duration * 12)) - 1);
                _payment = k * _credit;
            }
        }

        return this.each(function () {
            var $this = $(this), creditData = $this.data('creditCalc');
            var ui = {
                h1: $this.find('.js-title-wrapper'),
                credit: $this.find('.js-price-wrapper'),
                rate: $this.find('.js-rate-wrapper'),
                payment: $this.find('.js-payment-wrapper'),
                aboveMax: $this.find('.js-above-max-wrapper')
            };

            calc.init(creditData['price'], settings['percent']['val'], settings['duration']['val']);
            ui.h1.text(creditData['h1']);
            if (calc.isAbove())
                ui.aboveMax.removeClass('hidden');

            updateUi();

            $(document).on('creditModal.afterClose', function() {
                $inputSize.val(settings['percent']['val']);
                $inputTime.val(settings['duration']['val']);
                sliderSize.noUiSlider.set(settings['percent']['val']);
                sliderTime.noUiSlider.set(settings['duration']['val']);
                ui.aboveMax.addClass('hidden');
            });

            $inputSize.on('change', function() {
                sliderSize.noUiSlider.set($(this).val());
            });

            $inputTime.on('change', function() {
                sliderTime.noUiSlider.set($(this).val());
            });

            sliderSize.noUiSlider.on('update', function(values){
                var value = Math.round(values[0]);
                $inputSize.val(value);
                calc.setPercent(value);
                updateUi();
            });

            sliderTime.noUiSlider.on('update', function(values){
                var value = Math.round(values[0]);
                $inputTime.val(value);
                calc.setDuration(value);
                updateUi();
            });
            
            function updateUi() {
                ui.rate.text(calc.getRate() + '%');
                ui.credit.text(moneyFormat.to(calc.getCredit()));
                ui.payment.text(moneyFormat.to(calc.getPayment()));
            }
        });
    };
    // Credit calculator plugin ]
    
    // [ Client request modal plugin
    $.fn.clientRequestModal = function(options) {
        var settings = $.extend({
            btnText: 'Оставить заявку'
        }, options);
        
        var $modal = $('[data-remodal-id=feedbackModal]');
        var $form = $modal.find('form.client-feedback');
        var $btnText = $modal.find('.btn-text-wrapper');
        var $typeInput = $modal.find('input[name=type]');

        return this.each(function () {
            var $this = $(this);
            var modalInst = $modal.remodal({
                hashTracking: false,
                closeOnOutsideClick: false,
                modifier: 'is-default'
            });

            $this.click(function() {
                $btnText.text($this.data('btnText') || settings['btnText']);
                $typeInput.val($this.data('type'));
                modalInst.open();
            });

            $modal.on('closed', function (e) {
                $btnText.text('');
            });

            $form.on('request.success', function (e) {
                //modalInst.close();
            });
        });
    };
    // Client request modal plugin ]
    
    // [ Client request plugin
    $.fn.clientRequest = function(options) {
        var settings = $.extend({}, options);
        
        function send(data, onSuccess, onFail) {
            console.info('clientRequest', data);
            $.post('/feedback/create/', data, onSuccess, 'json').error(onFail);
        }

        return this.each(function () {
            var $this = $(this);
            var $success = $this.siblings('.client-feedback-success');
            var $fail = $this.siblings('.client-feedback-fail');
            var $writeMore = $success.find('.js-client-feedback-write-more');
            var $sendTrigger = $this.find('.js-client-feedback-trigger');
            var $inputs = $this.find('input, textarea, select');

            $sendTrigger.on('click', function(e) {
                e.preventDefault();

                $inputs.removeClass('has-error');

                var entity = pageContext['data']['entity'] || {};
                var data = $this.serializeObject(), extra = {url: window.location.href, title: (document.title || 'Title отсутствует!')};
                $.extend(data, extra, {data: entity});

                send(data, onSuccess, onFail);
            });

            $writeMore.on('click', function(e) {
                e.preventDefault();

                $this.removeClass('hide');
                $success.addClass('hide');
                $fail.addClass('hide');
            });

            function onSuccess(data) {
                $this[0].reset();
                $this.addClass('hide');
                $success.removeClass('hide');
                $this.trigger({type:"request.success", requestData: data});
            }

            function onFail(data) {
                for (var field in data.responseJSON) {
                    $this.find('[name="'+field+'"]').addClass('has-error');
                }
            }
        });
    };
    // Client request plugin ]
})(jQuery);
